// extracted by mini-css-extract-plugin
export default {"MappingFrom":"MappingForm_MappingFrom__H80sO","MappingBody":"MappingForm_MappingBody__OEkzD","Load":"MappingForm_Load__OF5oy","Form":"MappingForm_Form__soQ5-"};